import React from 'react'
import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import { isEmpty, getglobaldata, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, NumConv, GetDesitRound, isEnabled, initializedata } from '../modules/appLibrary';
import { styled } from '@material-ui/core/styles';
import { changestatus, listtabs, entrytriggercall, setgridlist, listoption } from '../modules/formstore';
import EntryBase from "../components/EntryBase";
import EntryGridAr from "../components/EntryGridAr";
import InputBase from '@material-ui/core/InputBase';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const BLExpenseIn = props => {

    const panelsdef = [];
    const formid = getformid("BLExpenseIn", props.location.search);
    const controller = getcontroller("BLExpenseIn", props.location.search);
    const entryController = "Forms:D_BKD";
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const menuinfo = useSelector(state => state.form.menuinfo);
    const staff = useSelector(state => state.user.accctl);
    const formstatus = useSelector(state => state.form.status);
    const entrylock = useSelector(
        state => state.form.entryformlock);
    const themestyle = useSelector(
        state => state.form.themestyle);

    const fnc = useRef();

    //データ
    const entrydataRef = useRef(null);
    const detailEntryDataRef = useRef(null);
    const detailDataRef = useRef([]);
    const detailColumnRef = useRef(null);
    const detailApiRef = useRef(null);
    const detailRequestIdRef = useRef(0);
    const blInfoTimerRef = useRef(null);

    const [panel, setpanel] = useState([]);
    const [columns, setcolumns] = useState([]);
    const [columninfo, setcolumninfo] = useState([]);
    const [editingCode, setEditingCode] = useState("");
    const [detailAmountValue,
        setDetailAmountValue] = useState("");
    const totalAmountRef = useRef(null);

    const dispatch = useDispatch();
    const search = useLocation().search;
    const ComFunc = React.forwardRef(ComFunction);


    const actionurl = {
        "update": "Forms/Update",
        "getlist": "BLExpenseIn/GetListData",
    }

    const navmenu = [
        {
            status: "VIEW",
            menuid: "allocate",
            icon: "call_split",
            label: "経費按分",
            title:
                "選択されたB/L No.の"
                + "経費按分を実行します",
        },
        {
            status: "VIEW",
            menuid: "viewdelete",
            icon: "delete",
            label: "削除",
            title:
                "選択されたB/L No.の"
                + "経費データを削除します",
        },
        {
            status: "VIEW",
            menuid: "sep",
        },
        {
            status: "VIEW",
            menuid: "excel",
            icon: "file_download",
            label: "Excel",
            title:
                "現在のシート内容を"
                + "Excelに出力します",
        },
    ]

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) {
            return;
        }

        fnc.current.postaxios(
            "common/GetListTabs",
            {
                panels: panelsdef,
                controller: entryController,
                subkey: subkey,
            },
            {
                onSuccess: function (data) {
                    const normalizedPanels = data.panels.map(
                        targetPanel =>
                            String(targetPanel.type) === "102"
                                ? {
                                    ...targetPanel,
                                    grid: true,
                                }
                                : targetPanel);

                    setpanel(normalizedPanels);

                    const detailPanel = normalizedPanels.find(
                        targetPanel =>
                            String(targetPanel.type) === "102");

                    dispatch(setgridlist(
                        isEmpty(detailPanel)
                            ? []
                            : [
                                {
                                    id: detailPanel.id,
                                    type: detailPanel.type,
                                    index: 0,
                                },
                            ]));
                    setcolumns(data.columns.map(column =>
                        column.columnid === "BKDM_BILLDATE"
                            ? {
                                ...column,
                                length: 0,
                            }
                            : column));

                    setcolumninfo(data.colinfo);

                    fnc.current.initMaster(data.master);
                    fnc.current.wait(false);
                },
            }
        );
    }, [search]);

    useEffect(() => {
        if (formstatus !== "COPY FORM"
            || isEmpty(columninfo)
            || isEmpty(entrydataRef.current)) {
            return;
        }

        const detailPanel = GetDetailPanel();
        const detailType = isEmpty(detailPanel)
            ? ""
            : String(detailPanel.type);
        const baseData = {
            ...entrydataRef.current,
        };
        const detailData =
            GetDetailRows().map(row => ({
                ...row,
            }));

        columninfo
            .filter(column => isEnabled(column.copyclear))
            .forEach(column => {
                if (String(column.type) === detailType) {
                    detailData.forEach(row => {
                        row[column.columnid] = "";
                    });
                } else {
                    baseData[column.columnid] = "";
                }
            });

        baseData.BKD_BLNO = "";
        entrydataRef.current = baseData;
        detailEntryDataRef.current = null;
        ApplyDetailGridData(detailData);
        detailRequestIdRef.current += 1;
        if (!isEmpty(blInfoTimerRef.current)) {
            clearTimeout(blInfoTimerRef.current);
            blInfoTimerRef.current = null;
        }
        setEditingCode("");
        CalculateTotal(detailData);
        Rerender();
    }, [formstatus, columninfo]);

    function Rerender() {
        if (fnc.current) {
            fnc.current.entryrerender();
        }
    }

    function ToNumber(value) {
        const normalizedValue =
            typeof value === "string"
                ? value.replace(/,/g, "")
                : value;

        return NumConv(normalizedValue);
    }

    function FormatDetailAmount(value) {
        const column = columns.find(item =>
            item.columnid === "BKDM_KINGAKU");
        const decimalPlace = isEmpty(column)
            ? 2
            : Number(column.decimalplace || 0);
        const numberValue = ToNumber(value);

        if (numberValue === 0) {
            return "";
        }

        return numberValue.toLocaleString(
            undefined,
            {
                minimumFractionDigits: decimalPlace,
                maximumFractionDigits: decimalPlace,
            });
    }

    function SetDetailAmountValue(row) {
        setDetailAmountValue(
            FormatDetailAmount(
                isEmpty(row)
                    ? 0
                    : row.BKDM_KINGAKU));
    }

    function ChangeDetailAmount(value) {
        setDetailAmountValue(value);
    }

    function CommitDetailAmount(value) {
        const targetRow = {
            ...detailEntryDataRef.current,
            BKDM_KINGAKU: ToNumber(value),
        };

        CalculateRowAmount(
            targetRow,
            "BKDM_KINGAKU");

        detailEntryDataRef.current =
            targetRow;

        fnc.current.modify();
        SetDetailAmountValue(
            targetRow);
        CalculateTotal();
        Rerender();
    }

    function DetailAmountInput() {
        return (
            <div
                style={{
                    boxSizing: 'border-box',
                    width: '25%',
                    height: 30,
                    display: 'flex',
                    border: 'solid 1px #ccc',
                }}
            >
                <div
                    className="fieldlabel"
                    style={{
                        cursor: 'context-menu',
                        backgroundColor:
                            themestyle.header.back,
                        color:
                            themestyle.header.color,
                        userSelect: 'none',
                        display: 'flex',
                        alignItems: 'center',
                        paddingTop: 0,
                        flexShrink: 0,
                    }}
                >
                    金額
                </div>
                <div
                    className="fieldinput"
                    style={{
                        position: 'relative',
                        backgroundColor: 'inset',
                        display: 'flex',
                        alignItems: 'center',
                        height: '100%',
                    }}
                >
                    <InputBase
                        fullWidth
                        style={{
                            height: '100%',
                        }}
                        value={detailAmountValue}
                        readOnly={entrylock}
                        inputProps={{
                            style: {
                                boxSizing: 'border-box',
                                width: '100%',
                                textAlign: 'right',
                                fontSize: 12,
                                paddingRight: 15,
                            },
                            autoComplete: 'off',
                        }}
                        onChange={event =>
                            ChangeDetailAmount(
                                event.target.value)}
                        onFocus={event => {
                            setDetailAmountValue(
                                event.target.value
                                    .replace(/,/g, ""));
                            event.target.select();
                        }}
                        onBlur={event =>
                            CommitDetailAmount(
                                event.target.value)}
                        onKeyDown={event => {
                            if (event.key !== "Enter") {
                                return;
                            }

                            event.preventDefault();
                            event.currentTarget.blur();
                        }}
                    />
                </div>
            </div>
        );
    }

    function GetDetailPanel() {
        let detailPanel = panel.find(item =>
            String(item.type) === "102");

        if (isEmpty(detailPanel)) {
            detailPanel = panel.find(item => item.grid);
        }

        return detailPanel;
    }

    function GetPanelFields(targetPanel) {
        if (isEmpty(columns)) {
            return [];
        }

        return columns.filter(column =>
            String(column.logpid) === String(targetPanel.id)
            && String(column.type) === String(targetPanel.type));
    }

    function IsDetailGridMode(targetPanel) {
        const gridStatuses = [
            "ENTRY FORM",
            "NEW FORM",
            "COPY FORM",
        ];

        return !isEmpty(targetPanel)
            && String(targetPanel.type) === "102"
            && targetPanel.grid
            && gridStatuses.includes(formstatus);
    }

    function ApplyDetailGridData(rows) {
        const detailRows = Array.isArray(rows)
            ? rows
            : [];

        detailDataRef.current = detailRows;

        const api = detailApiRef.current;

        if (isEmpty(api)
            || (typeof api.isDestroyed === "function"
                && api.isDestroyed())) {
            return;
        }

        if (typeof api.setGridOption === "function") {
            api.setGridOption("rowData", detailRows);
            return;
        }

        if (typeof api.setRowData === "function") {
            api.setRowData(detailRows);
        }
    }

    function GetDetailRows() {
        const detailPanel = GetDetailPanel();

        if (!IsDetailGridMode(detailPanel)) {
            const loadedRows =
                Array.isArray(detailDataRef.current)
                    ? detailDataRef.current
                    : [];

            if (isEmpty(detailEntryDataRef.current)) {
                return loadedRows;
            }

            return loadedRows.length === 0
                ? [detailEntryDataRef.current]
                : [
                    detailEntryDataRef.current,
                    ...loadedRows.slice(1),
                ];
        }

        if (!isEmpty(detailApiRef.current)) {
            const rows = [];

            detailApiRef.current.forEachNode(node => {
                rows.push(node.data);
            });

            detailDataRef.current = rows;
        }

        return Array.isArray(detailDataRef.current)
            ? detailDataRef.current
            : [];
    }

    function CalculateTotal(rows) {
        const source = Array.isArray(rows)
            ? rows
            : GetDetailRows();

        const total = source.reduce(
            (result, row) =>
                result + ToNumber(row.BKDM_KINGAKU),
            0);

        if (!isEmpty(totalAmountRef.current)) {
            totalAmountRef.current.textContent =
                total.toLocaleString(
                    undefined,
                    {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    });
        }
    }

    function SetDetailData(rows) {
        const detailPanel = GetDetailPanel();
        const detailRows = Array.isArray(rows)
            ? DeepCopy(rows)
            : [];

        if (!IsDetailGridMode(detailPanel)) {
            detailEntryDataRef.current =
                detailRows.length === 0
                    ? {}
                    : detailRows[0];
            ApplyDetailGridData(detailRows);
            SetDetailAmountValue(
                detailEntryDataRef.current);
        } else {
            detailEntryDataRef.current = null;
            ApplyDetailGridData(detailRows);
        }

        CalculateTotal(GetDetailRows());
    }

    function InitializeEntryForm() {
        const detailPanel = GetDetailPanel();

        detailRequestIdRef.current += 1;

        const baseFields = columns.filter(column =>
            isEmpty(detailPanel)
            || String(column.type)
                !== String(detailPanel.type));

        const detailFields = isEmpty(detailPanel)
            ? []
            : GetPanelFields(detailPanel);

        entrydataRef.current =
            initializedata(baseFields, staff) || {};

        detailEntryDataRef.current =
            initializedata(detailFields, staff) || {};
        SetDetailAmountValue(
            detailEntryDataRef.current);

        detailDataRef.current = [];
        setEditingCode("");

        fnc.current.modify(false);
        Rerender();

        fnc.current.postaxios(
            "common/GetInitSqlValue",
            {
                colinfo: baseFields,
            },
            {
                onSuccess: function (data) {
                    const returnData =
                        data.returnData || {};

                    const initializedFields =
                        baseFields.map(field => ({
                            ...field,
                            initvalue:
                                Object.prototype.hasOwnProperty.call(
                                    returnData,
                                    field.columnid)
                                    ? returnData[field.columnid]
                                    : field.initvalue,
                        }));

                    entrydataRef.current =
                        initializedata(
                            initializedFields,
                            staff) || {};

                    Rerender();
                },
            },
            true
        );
    }

    function LoadData(code) {
        const detailPanel = GetDetailPanel();

        detailRequestIdRef.current += 1;

        fnc.current.wait(true);

        fnc.current.postaxios(
            "BLExpenseIn/GetData",
            {
                code: code,
                controller: entryController,
                colinfo: columninfo,
            },
            {
                onSuccess: function (data) {
                    fnc.current.margeMaster(data.master);

                    entrydataRef.current =
                        isEmpty(data.data)
                            ? {}
                            : data.data;

                    const detailType =
                        isEmpty(detailPanel)
                            ? "102"
                            : String(detailPanel.type);

                    const detail =
                        isEmpty(data.detail)
                            ? []
                            : data.detail[detailType];

                    SetDetailData(detail);
                    setEditingCode(code);

                    fnc.current.modify(false);
                    Rerender();
                    fnc.current.wait(false);

                },
                onError: function (data) {
                    let message =
                        "登録後のデータ再取得に失敗しました";

                    if (!isEmpty(
                        data?.errDescription)) {
                        message =
                            data.errDescription;
                    }

                    fnc.current.wait(false);
                    fnc.current.warnmsg(message);
                },
                errmsg:
                    "登録後のデータ再取得に失敗しました",
            }
        );
    }

    function Getrowid() {
        const data =
            getglobaldata("entryrowdata");

        return isEmpty(data)
            ? ""
            : data.rowid;
    }

    function IsDetailInputRow(row) {
        if (isEmpty(row)) {
            return false;
        }

        const inputColumns = [
            "BKDM_SIHARAISAKI",
            "BKDM_BILLNO",
            "BKDM_BILLDATE",
            "BKDM_KEIHIKAMOKU",
            "BKDM_TSUKATANI",
        ];

        return inputColumns.some(column => {
            const value = row[column];

            return !isEmpty(value)
                && String(value).trim() !== "0";
        })
            || ToNumber(row.BKDM_KINGAKUF) !== 0
            || ToNumber(row.BKDM_KINGAKU) !== 0;
    }

    function BuildEntryParamData(noconfirm) {
        const blNo =
            entrydataRef.current.BKD_BLNO;

        const detailPanel = GetDetailPanel();
        const detailRows =
            !IsDetailGridMode(detailPanel)
                ? [
                    {
                        ...detailEntryDataRef.current,
                        BKDM_KINGAKU:
                            ToNumber(detailAmountValue),
                    },
                ]
                : GetDetailRows();

        const rows = detailRows
            .filter(row => IsDetailInputRow(row))
            .map((row, index) => {
                const saveRow = {
                    ...row,
                    BKDM_BLNO: blNo,
                    BKDM_GYONO: index + 1,
                    BKDM_CUR: isEmpty(row.BKDM_CUR)
                        ? "2"
                        : row.BKDM_CUR,
                    BKDM_RATE: ToNumber(row.BKDM_RATE),
                    BKDM_KINGAKUF:
                        ToNumber(row.BKDM_KINGAKUF),
                    BKDM_KINGAKU:
                        ToNumber(row.BKDM_KINGAKU),
                };

                CalculateRowAmount(saveRow);

                return saveRow;
            });

        return {
            controller: entryController,
            data: {
                ...entrydataRef.current,
            },
            detail: {
                "102": rows,
            },
            colinfo: columninfo,
            code: editingCode,
            noconfirm: noconfirm,
        };
    }

    function Save(finallycallback, noconfirm) {
        const isEntryForm =
            formstatus === "ENTRY FORM";

        const paramdata =
            BuildEntryParamData(noconfirm);

        const saveUrl = isEntryForm
            ? "BLExpenseIn/UpdateEntry"
            : "BLExpenseIn/InsertEntry";

        fnc.current.wait(true);

        fnc.current.postaxios(
            saveUrl,
            paramdata,
            {
                onSuccess: function (data) {
                    const warnings =
                        Array.isArray(data.warning)
                            ? data.warning
                            : [];

                    if (warnings.length === 0) {
                        const code =
                            data.request
                            || paramdata.data.BKD_BLNO;

                        if (isEntryForm
                            && !isEmpty(data.data)) {
                            entrydataRef.current = {
                                ...entrydataRef.current,
                                ...data.data,
                            };
                        }

                        fnc.current.modify(false);

                        if (!isEntryForm) {
                            entrydataRef.current = {
                                ...entrydataRef.current,
                                BKD_BLNO: code,
                            };

                            setEditingCode(code);

                            dispatch(
                                changestatus(
                                    "ENTRY FORM"));
                        }

                        if (isEntryForm
                            && typeof finallycallback
                            === "function") {
                            const listData =
                                isEmpty(data.data)
                                    ? {
                                        ...entrydataRef.current,
                                    }
                                    : data.data;

                            listData.rowid = Getrowid();

                            listData.BKDM_KINGAKU_TOTAL =
                                paramdata.detail["102"]
                                    .reduce(
                                        (total, row) =>
                                            total
                                            + ToNumber(
                                                row.BKDM_KINGAKU),
                                        0);

                            finallycallback(listData);
                        }

                        fnc.current.success();
                        LoadData(code);
                    } else if (
                        isEnabled(data.confirm)) {
                        const messages = [
                            "内容を確認し、そのまま登録する場合はOK、修正する場合はCancelを選択してください。",
                            "　",
                        ];

                        warnings.forEach(warning => {
                            messages.push(
                                "・" + warning.message);
                        });

                        fnc.current.confmsg(
                            messages,
                            () => Save(
                                finallycallback,
                                true));
                    } else {
                        const message =
                            warnings.length
                            + "件の制約違反により"
                            + "登録できませんでした。";

                        fnc.current.showwarndescription(
                            message,
                            warnings);
                    }

                    fnc.current.wait(false);
                },
                onError: function (data) {
                    let message =
                        "登録に失敗しました";

                    if (!isEmpty(
                        data?.errDescription)) {
                        message =
                            data.errDescription;
                    }

                    fnc.current.warnmsg(message);
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました",
            }
        );
    }

    function Delete(
        finallycallback,
        noconfirm = false,
        targetBlNo = "") {
        const entryData =
            isEmpty(entrydataRef.current)
                ? {}
                : entrydataRef.current;
        const blNo =
            !isEmpty(targetBlNo)
                ? targetBlNo
                : !isEmpty(editingCode)
                ? editingCode
                : entryData.BKD_BLNO;

        const param = {
            code: blNo,
            data: !isEmpty(targetBlNo)
                ? {
                    BKD_BLNO: blNo,
                }
                : entryData,
            rowdata: [
                {
                    BKD_BLNO: blNo,
                    rowid: blNo,
                },
            ],
            controller: controller,
            noconfirm: noconfirm,
        };

        fnc.current.wait(true);

        fnc.current.postaxios(
            "BLExpenseIn/Delete",
            param,
            {
                onSuccess: function (data) {
                    const warnings =
                        Array.isArray(data.warning)
                            ? data.warning
                            : [];

                    if (warnings.length === 0) {
                        fnc.current.modify(false);
                        fnc.current.success();

                        if (typeof finallycallback
                            === "function") {
                            finallycallback(
                                blNo,
                                ["BKD_BLNO"]);
                        }
                    } else if (
                        isEnabled(data.confirm)) {
                        const messages =
                            warnings.map(
                                warning =>
                                    warning.message);

                        fnc.current.confmsg(
                            messages,
                            () => Delete(
                                finallycallback,
                                true,
                                targetBlNo));
                    } else {
                        fnc.current.showwarndescription(
                            "このデータは削除できません。",
                            warnings);
                    }

                    fnc.current.wait(false);
                },
                onError: function (data) {
                    fnc.current.warnmsg(
                        !isEmpty(data?.errDescription)
                            ? data.errDescription
                            : "削除に失敗しました");
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました",
            }
        );
    }

    function RoundAmount(
        value,
        columnId) {
        const column = columns.find(item =>
            item.columnid === columnId);

        const decimalPlace =
            !isEmpty(column)
            && Number.isFinite(
                Number(column.decimalplace))
                ? Number(column.decimalplace)
                : 2;

        const hasRounding =
            !isEmpty(column)
            && column.rounding !== undefined
            && column.rounding !== null
            && String(column.rounding).trim() !== "";

        const rounding = hasRounding
            ? column.rounding
            : 1;

        return GetDesitRound(
            ToNumber(value),
            rounding,
            decimalPlace);
    }

    function CalculateRowAmount(
        row,
        changedColumn) {
        const currency =
            String(
                row.BKDM_TSUKATANI || "")
                .toUpperCase();

        const rate =
            ToNumber(row.BKDM_RATE);

        if (currency === "JPY") {
            row.BKDM_KINGAKUF = 0;
            return;
        }

        if (rate === 0) {
            return;
        }

        if (changedColumn
            === "BKDM_KINGAKUF") {
            row.BKDM_KINGAKU =
                RoundAmount(
                    ToNumber(
                        row.BKDM_KINGAKUF)
                    * rate,
                    "BKDM_KINGAKU");

            return;
        }

        if (changedColumn
            === "BKDM_KINGAKU") {
            row.BKDM_KINGAKUF =
                RoundAmount(
                    ToNumber(
                        row.BKDM_KINGAKU)
                    / rate,
                    "BKDM_KINGAKUF");

            return;
        }

        if (ToNumber(
            row.BKDM_KINGAKUF) !== 0) {
            row.BKDM_KINGAKU =
                RoundAmount(
                    ToNumber(
                        row.BKDM_KINGAKUF)
                    * rate,
                    "BKDM_KINGAKU");
        } else if (
            ToNumber(
                row.BKDM_KINGAKU) !== 0) {
            row.BKDM_KINGAKUF =
                RoundAmount(
                    ToNumber(
                        row.BKDM_KINGAKU)
                    / rate,
                    "BKDM_KINGAKUF");
        }
    }

    function RefreshDetailRow(params) {
        if (isEmpty(params)
            || isEmpty(params.api)) {
            return;
        }

        params.api.refreshCells({
            rowNodes: isEmpty(params.node)
                ? undefined
                : [params.node],
            force: true,
        });

        CalculateTotal();
    }

    function LoadExpenseDetailInfo(
        row,
        changedColumn,
        params) {
        const isGridRow =
            !isEmpty(params)
            && !isEmpty(params.api);

        const requestId = isGridRow
            ? 0
            : ++detailRequestIdRef.current;

        const requestData = {
            ...row,
            BKD_BLNO:
                entrydataRef.current.BKD_BLNO,
        };

        fnc.current.postaxios(
            "BLExpenseIn/GetExpenseDetailInfo",
            {
                code:
                    entrydataRef.current.BKD_BLNO,
                data: requestData,
            },
            {
                onSuccess: function (data) {
                    if (!isGridRow
                        && requestId
                            !== detailRequestIdRef.current) {
                        return;
                    }

                    let targetRow =
                        isGridRow
                            ? row
                            : {
                                ...detailEntryDataRef.current,
                            };

                    if (!isEmpty(data.returnData)) {
                        if (isGridRow) {
                            Object.assign(
                                targetRow,
                                data.returnData);
                        } else {
                            targetRow = {
                                ...targetRow,
                                ...data.returnData,
                            };
                        }
                    }

                    if (!isGridRow) {
                        detailEntryDataRef.current =
                            targetRow;
                    }

                    if (changedColumn
                        === "BKDM_BILLDATE") {
                        CalculateRowAmount(
                            targetRow,
                            "BKDM_KINGAKU");
                    }

                    if (!isGridRow) {
                        SetDetailAmountValue(
                            targetRow);
                    }

                    if (isGridRow) {
                        RefreshDetailRow(params);
                    } else {
                        CalculateTotal();
                        Rerender();
                    }
                },
                errmsg:
                    "名称・通貨レートの取得に失敗しました",
            },
            true
        );
    }

    function BasicValueChanged(id, value) {
        if (id !== "BKD_BLNO") {
            return;
        }

        if (!isEmpty(blInfoTimerRef.current)) {
            clearTimeout(blInfoTimerRef.current);
            blInfoTimerRef.current = null;
        }

        detailRequestIdRef.current += 1;

        if (isEmpty(value)) {
            entrydataRef.current = {
                ...entrydataRef.current,
                BKD_TUKANBI: "",
            };

            Rerender();
            return;
        }

        fnc.current.postaxios(
            "BLExpenseIn/GetBlInfo",
            {
                code: value,
                data: {
                    BKD_BLNO: value,
                },
            },
            {
                onSuccess: function (data) {
                    if (!isEmpty(data.returnData)) {
                        entrydataRef.current = {
                            ...entrydataRef.current,
                            ...data.returnData,
                        };
                    }

                    Rerender();
                },
                onError: function (data) {
                    entrydataRef.current = {
                        ...entrydataRef.current,
                        BKD_TUKANBI: "",
                    };

                    Rerender();

                    fnc.current.warnmsg(
                        !isEmpty(data?.errDescription)
                            ? data.errDescription
                            : "B/L情報の取得に失敗しました");
                },
                errmsg:
                    "B/L情報の取得に失敗しました",
            },
            true
        );
    }

    function BasicValueChanging(id, value) {
        if (id !== "BKD_BLNO") {
            return;
        }

        if (!isEmpty(blInfoTimerRef.current)) {
            clearTimeout(blInfoTimerRef.current);
        }

        blInfoTimerRef.current = setTimeout(() => {
            blInfoTimerRef.current = null;
            BasicValueChanged(id, value);
        }, 600);
    }

    function BaseValueChanged(id, value) {
        if (id === "BKD_BLNO") {
            BasicValueChanged(id, value);
            return;
        }

        const amountColumns = [
            "BKDM_KINGAKUF",
            "BKDM_KINGAKU",
        ];

        if (amountColumns.includes(id)) {
            const targetRow = {
                ...detailEntryDataRef.current,
                [id]: ToNumber(value),
            };

            CalculateRowAmount(
                targetRow,
                id);

            detailEntryDataRef.current =
                targetRow;

            SetDetailAmountValue(
                targetRow);
            CalculateTotal();

            return;
        }

        const referenceColumns = [
            "BKDM_SIHARAISAKI",
            "BKDM_BILLDATE",
            "BKDM_KEIHIKAMOKU",
            "BKDM_TSUKATANI",
            "BKDM_CUR",
        ];

        if (!referenceColumns.includes(id)) {
            return;
        }

        let targetRow = {
            ...detailEntryDataRef.current,
            [id]: value,
        };

        if (id === "BKDM_TSUKATANI"
            || id === "BKDM_CUR") {
            targetRow = {
                ...targetRow,
                BKDM_CUR: "2",
                BKDM_RATE: 0,
                BKDM_KINGAKUF: 0,
                BKDM_KINGAKU: 0,
            };

            detailEntryDataRef.current =
                targetRow;

            SetDetailAmountValue(
                targetRow);
            CalculateTotal();
            Rerender();
        }

        LoadExpenseDetailInfo(
            targetRow,
            id,
            null);
    }

    function DetailValueChanged(params) {
        if (isEmpty(params)
            || isEmpty(params.data)) {
            CalculateTotal();
            return;
        }

        const row = params.data;

        const changedColumn =
            !isEmpty(params.colDef.field)
                ? params.colDef.field
                : params.colDef.colId;

        if (changedColumn
            === "BKDM_KINGAKUF"
            || changedColumn
                === "BKDM_KINGAKU") {
            CalculateRowAmount(
                row,
                changedColumn);

            RefreshDetailRow(params);
            return;
        }

        const referenceColumns = [
            "BKDM_SIHARAISAKI",
            "BKDM_BILLDATE",
            "BKDM_KEIHIKAMOKU",
            "BKDM_TSUKATANI",
            "BKDM_CUR",
        ];

        if (referenceColumns.includes(
            changedColumn)) {
            if (changedColumn
                === "BKDM_TSUKATANI"
                || changedColumn === "BKDM_CUR") {
                Object.assign(
                    row,
                    {
                        BKDM_CUR: "2",
                        BKDM_RATE: 0,
                        BKDM_KINGAKUF: 0,
                        BKDM_KINGAKU: 0,
                    });

                RefreshDetailRow(params);
            }

            LoadExpenseDetailInfo(
                row,
                changedColumn,
                params);

            return;
        }

        CalculateTotal();
    }

    function Show(data, pushcode) {
        if (isEmpty(columninfo)) {
            return false;
        }

        const source = isEmpty(data)
            ? {}
            : DeepCopy(data);

        const code = !isEmpty(pushcode)
            ? pushcode
            : !isEmpty(source.BKD_BLNO)
                ? source.BKD_BLNO
                : formstatus === "ENTRY FORM"
                    ? editingCode
                    : "";

        if (!isEmpty(data)) {
            setglobaldata("entryrowdata", data);
        }

        if (isEmpty(code)) {
            InitializeEntryForm();
        } else {
            LoadData(code);
        }

        return true;
    }

    function Allocate(
        selectedRow,
        getList,
        noconfirm = false) {
        const blNo =
            selectedRow.BKD_BLNO;

        const param = {
            code: blNo,
            data: {
                BKD_BLNO: blNo,
            },
            rowdata: [
                selectedRow,
            ],
            controller: controller,
            noconfirm: noconfirm,
        };

        fnc.current.wait(true);

        fnc.current.postaxios(
            "BLExpenseIn/Allocate",
            param,
            {
                onSuccess: function (data) {
                    const warnings =
                        Array.isArray(data.warning)
                            ? data.warning
                            : [];

                    if (warnings.length === 0) {
                        fnc.current.success();

                        if (typeof getList
                            === "function") {
                            getList(false);
                        }
                    } else if (
                        isEnabled(data.confirm)) {
                        const messages =
                            warnings.map(
                                warning =>
                                    warning.message);

                        fnc.current.confmsg(
                            messages,
                            () => Allocate(
                                selectedRow,
                                getList,
                                true));
                    } else {
                        fnc.current
                            .showwarndescription(
                                "経費按分を"
                                + "実行できませんでした。",
                                warnings);
                    }

                    fnc.current.wait(false);
                },
                onError: function (data) {
                    let message =
                        "経費按分の実行に失敗しました";

                    if (!isEmpty(
                        data?.errDescription)) {
                        message = data.errDescription;
                    }

                    fnc.current.warnmsg(message);
                    fnc.current.wait(false);
                },
                errmsg:
                    "経費按分の実行に失敗しました",
            }
        );
    }

    function EntryAction(
        menu,
        finallycallback,
        getList,
        gridApi) {
        if (menu === "viewdelete") {
            if (isEmpty(gridApi)) {
                fnc.current.warnmsg(
                    "一覧情報を取得できませんでした");
                return;
            }

            const selectedRows =
                gridApi.getSelectedRows();

            if (isEmpty(selectedRows)
                || selectedRows.length === 0) {
                fnc.current.warnmsg(
                    "削除するデータを選択してください");
                return;
            }

            if (selectedRows.length !== 1) {
                fnc.current.warnmsg(
                    "削除は1行ずつ実行してください");
                return;
            }

            const blNo =
                selectedRows[0].BKD_BLNO;

            if (isEmpty(blNo)) {
                fnc.current.warnmsg(
                    "B/L No.を取得できませんでした");
                return;
            }

            const message =
                "B/L No.「"
                + blNo
                + "」の経費データを削除します。"
                + "データの復帰はできません。"
                + "よろしいですか？";

            fnc.current.confmsg(
                message,
                () => Delete(
                    () => {
                        if (typeof gridApi.deselectAll
                            === "function") {
                            gridApi.deselectAll();
                        }

                        if (typeof getList
                            === "function") {
                            getList(false);
                        }
                    },
                    false,
                    blNo));

            return;
        }

        if (menu === "allocate") {
            if (isEmpty(gridApi)) {
                fnc.current.warnmsg(
                    "一覧情報を取得できませんでした");
                return;
            }

            const selectedRows =
                gridApi.getSelectedRows();

            if (isEmpty(selectedRows)
                || selectedRows.length === 0) {
                fnc.current.warnmsg(
                    "経費按分を行う行を"
                    + "選択してください");
                return;
            }

            if (selectedRows.length !== 1) {
                fnc.current.warnmsg(
                    "経費按分は1行ずつ"
                    + "実行してください");
                return;
            }

            const selectedRow =
                selectedRows[0];

            const blNo =
                selectedRow.BKD_BLNO;

            if (isEmpty(blNo)) {
                fnc.current.warnmsg(
                    "B/L No.を取得できませんでした");
                return;
            }

            const message =
                "B/L No.「"
                + blNo
                + "」の経費按分を実行します。"
                + "よろしいですか？";

            fnc.current.confmsg(
                message,
                () => Allocate(
                    selectedRow,
                    getList,
                    false));

            return;
        }

        if (menu === "save") {
            Save(finallycallback, false);
            return;
        }

        if (menu === "delete") {
            Delete(finallycallback);
            return;
        }

        if (menu === "clear") {
            if (formstatus === "ENTRY FORM"
                && !isEmpty(editingCode)) {
                LoadData(editingCode);
            } else {
                InitializeEntryForm();
            }

            return;
        }

        if (menu === "close") {
            detailRequestIdRef.current += 1;
            if (!isEmpty(blInfoTimerRef.current)) {
                clearTimeout(blInfoTimerRef.current);
                blInfoTimerRef.current = null;
            }
            entrydataRef.current = null;
            detailEntryDataRef.current = null;
            detailDataRef.current = [];
            detailApiRef.current = null;
            setEditingCode("");
        }
    }

    function PanelContents(targetPanel) {
        const isDetailPanel =
            String(targetPanel.type) === "102";

        if (!targetPanel.grid
            || (isDetailPanel
                && !IsDetailGridMode(targetPanel))) {
            const targetDataRef =
                isDetailPanel
                    ? detailEntryDataRef
                    : entrydataRef;
            const panelFields =
                GetPanelFields(targetPanel);

            return (
                <React.Fragment>
                    <EntryBase
                        fnc={fnc}
                        textfields={
                            isDetailPanel
                                ? panelFields.filter(field =>
                                    field.columnid
                                        !== "BKDM_KINGAKU")
                                : panelFields
                        }
                        panel={targetPanel}
                        entrydataRef={targetDataRef}
                        ValueChanged={BaseValueChanged}
                        ValueChangeing={BasicValueChanging}
                    />
                    {isDetailPanel
                        ? DetailAmountInput()
                        : null}
                </React.Fragment>
            );
        }

        return (
            <EntryGridAr
                id={fnc.current.GridID(targetPanel)}
                entrydataRef={entrydataRef}
                dataRef={detailDataRef}
                columnRef={detailColumnRef}
                columninfo={columninfo}
                columns={columns}
                fnc={fnc}
                formid={formid}
                panel={targetPanel}
                ValueChanged={DetailValueChanged}
                onGridReady={params => {
                    detailApiRef.current = params.api;
                    if (Array.isArray(detailDataRef.current)
                        && detailDataRef.current.length > 0) {
                        ApplyDetailGridData(
                            detailDataRef.current);
                    }
                }}
            />
        );
    }

    function EntryForm() {
        return (
            <div
                style={{
                    padding: '5px 15px',
                    paddingBottom: '100px',
                    height: '100%',
                    overflow: 'auto',
                    backgroundColor: '#D8D8D8',
                }}
            >
                {panel.map((item, index) => (
                    <Box
                        key={
                            item.id
                            + "_"
                            + item.type
                            + "_"
                            + index
                        }
                        display={
                            item.hide
                                ? "none"
                                : "flex"
                        }
                        justifyContent="space-around"
                        alignItems="center"
                        padding="5px"
                    >
                        <Paper
                            style={{
                                width: '100%',
                                height: 'auto',
                                padding: 10,
                            }}
                        >
                            <div
                                style={{
                                    position: 'relative',
                                    marginBottom: 5,
                                }}
                            >
                                {item.name}
                            </div>

                            {PanelContents(item)}
                        </Paper>
                    </Box>
                ))}

                <Box
                    display="flex"
                    justifyContent="flex-end"
                    padding="5px"
                >
                    <Paper
                        style={{
                            width: 320,
                            padding: 10,
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent:
                                    'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <span>合計金額</span>

                            <span
                                ref={totalAmountRef}
                                style={{
                                    fontSize: 18,
                                    fontWeight: 'bold',
                                    textAlign: 'right',
                                }}
                            >
                                0.00
                            </span>
                        </div>
                    </Paper>
                </Box>
            </div>
        );
    }

    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                entrycallback={EntryAction}
                entryform={true}
                tabs={true}
                show={Show}
                navmenu={navmenu}
                entrydataRef={entrydataRef}
                usecondition={true}
            >
                {EntryForm()}
            </MasterBase>
        </div>
    );
};
